import * as React from 'react'
import { UserContext } from './context/useUserContext'
import LoginModal from './common/LoginModal'

const LoggedOutModal: React.FunctionComponent = (props) => {
	const user = React.useContext(UserContext)

	const respondToLogin = async () => {
		await user.refresh()
	}
	if (user.meta === 'not logged in') {
		return (
			<>
				{props.children}
				<LoginModal respondToLogin={respondToLogin} />
			</>
		)
	}
	return <>{props.children}</>
}

export default LoggedOutModal
